<template>
  <div class="sidebar-wrap">

    <time class="activities-today__date"
      :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
    >{{ dateFormat(new Date(), 'dddd, MMMM DD, YYYY') }}</time>

    <template v-if="sales !== null">
      <today-tile
        :amount="number(sales.amount)"
        :chart-data="salesByHour"
        name="Sales"
        :now="now"
        :previous-amount="number(sales.previous_amount)"
        :type="sales.type"
      ></today-tile>
    </template>
    <template v-else>
      <section class="activities-today activities-today--sales"
        :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
      >
        <div class="activities-today__container">
          <header class="activities-today__header">
            <h2 class="activities-today__title">Sales</h2>
          </header>
          <placeholder></placeholder>
        </div>
      </section>
    </template>

    <template v-if="googleToday !== null">
      <today-tile
        :amount="number(googleToday.users)"
        name="Visitors"
        :now="now"
        :previous-amount="number(googleToday.users_previous)"
        :type="'int'"
      ></today-tile>
    </template>
    <template v-else-if="googleIntegrated === false">
      <section class="activities-today activities-today--visitors"
        :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
      >
        <div class="activities-today__container">
          <header class="activities-today__header">
            <h2 class="activities-today__title">Visitors</h2>
          </header>
          <placeholder type="google"></placeholder>
        </div>
      </section>
    </template>
    <template v-else>
      <section class="activities-today activities-today--visitors"
        :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
      >
        <div class="activities-today__container">
          <header class="activities-today__header">
            <h2 class="activities-today__title">Visitors</h2>
          </header>
          <placeholder></placeholder>
        </div>
      </section>
    </template>

    <template v-if="orders !== null">
      <today-tile
        :amount="number(orders.amount)"
        name="Orders"
        :now="now"
        :previous-amount="number(orders.previous_amount)"
        :type="orders.type"
      ></today-tile>
    </template>
    <template v-else>
      <section class="activities-today activities-today--orders"
        :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
      >
        <div class="activities-today__container">
          <header class="activities-today__header">
            <h2 class="activities-today__title">Orders</h2>
          </header>
          <placeholder></placeholder>
        </div>
      </section>
    </template>

    <section class="activities-today activities-today--orders-to-fulfill"
      :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
    >
      <div class="activities-today__container">
        <header class="activities-today__header">
          <h2 class="activities-today__title">Orders to Fulfill</h2>
        </header>

        <template v-if="unfulfilledOrders !== null">
          <div class="activities-today-columns activities-today-columns--single">
            <p class="activities-today__result activities-today__result--28">
              {{ unfulfilledOrders.count }}
              <a class="activities-today__link" target="_blank"
                :href="unfulfilledOrders._links.self_shopify.href"
              >
                <i class="activities-today__icon icon--edit"></i>
              </a>
            </p>
          </div>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

    <template v-if="aov !== null">
      <today-tile
        :amount="number(aov.amount)"
        name="Average Order Value"
        :now="now"
        :previous-amount="number(aov.previous_amount)"
        :type="aov.type"
      ></today-tile>
    </template>
    <template v-else>
      <section class="activities-today activities-today--average-order-value"
        :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
      >
        <div class="activities-today__container">
          <header class="activities-today__header">
            <h2 class="activities-today__title">Average Order Value</h2>
          </header>
          <placeholder></placeholder>
        </div>
      </section>
    </template>

    <template v-if="googleToday !== null">
      <today-tile
        :amount="number(googleToday.conversion_rate)"
        name="Conversion Rate"
        :now="now"
        :previous-amount="number(googleToday.conversion_rate_previous)"
        :type="'percent'"
      ></today-tile>
    </template>
    <template v-else>
      <section class="activities-today activities-today--conversion-rate"
        :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
      >
        <div class="activities-today__container">
          <header class="activities-today__header">
            <h2 class="activities-today__title">Conversion Rate</h2>
          </header>
          <placeholder></placeholder>
        </div>
      </section>
    </template>

    <section class="activities-today activities-today--top-products"
      v-if="topProducts !== false"
      :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
    >
      <div class="activities-today__container">
        <header class="activities-today__header">
          <h2 class="activities-today__title">Top Products</h2>
        </header>

        <template v-if="topProducts !== null">
          <div class="activities-today-columns">
            <ul class="activities-today__list">
              <li class="activities-today__item"
                v-for="(p, key) in topProducts"
                :key="key"
              >
                <div class="activities-today-product__image"
                  :style="{ backgroundImage: `url(${ p.image.url })` }"
                >
                  <div class="activities-today-product__overlay">
                    <div class="activities-today-product__inner">
                      <p class="activities-today-product__units">{{ p.sales.quantity }}</p>
                      <small class="activities-today__info">Sold</small>
                    </div>
                  </div>
                </div>

                <div class="activities-today-product__info">
                  <p class="activities-today__result activities-today__result--12">{{ p.title }}</p>
                  <p class="activities-today-product__result">{{ p.sales.price | currency }}</p>
                  <small class="activities-today__info">Total</small>
                </div>
              </li>
            </ul>
          </div>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

    <section class="activities-today activities-today--top-customer"
      v-if="topCustomer !== false"
      :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
    >
      <div class="activities-today__container">
        <header class="activities-today__header">
          <h2 class="activities-today__title">Top Customer</h2>
        </header>

        <template v-if="topCustomer !== null">
          <div class="activities-today-columns activities-today-columns--single">
            <p class="activities-today__result activities-today__result--24">{{ topCustomer.name }}</p>
          </div>
          <div class="activities-today-columns activities-today-columns--single">
            <div class="activities-today-customer__info">
              <p>{{ topCustomer.orders_count > 1 ? 'Returning Customer' : 'New Customer' }}</p>
              <p>Irvine, CA</p>
            </div>
          </div>
          <div class="activities-today-columns activities-today-columns--single">
            <p class="activities-today__result activities-today__result--28">{{ topCustomer.sales.net_price | currency }}</p>
            <small class="activities-today__info">Total Purchase Amount</small>
          </div>
        </template>
        <template v-else>
          <placeholder></placeholder>
        </template>
      </div>
    </section>

    <!--
    <section class="activities-today-button"
      :class="{ 'scrollmagic__today-fade-in-up': !$firefox }"
    >
      <a class="activities-today__button">View Detailed Analytics</a>
    </section>
    -->

  </div>
</template>

<script>
  import TodayTile from '@/components/TodayTile'

  import { helpers } from '@/mixins/helpers.js'
  import { refresh } from '@/mixins/refresh.js'

  import _clone from 'lodash/clone'
  import _find from 'lodash/find'
  import _has from 'lodash/has'
  import _keyBy from 'lodash/keyBy'
  import axios from 'axios'
  import ifvisible from 'ifvisible.js'
  import ScrollMagic from 'scrollmagic'
  // import 'debug.addIndicators' // Debug tool for scrollmagic
  import moment from 'moment'
  import Vue from 'vue'

  let Placeholder = Vue.component('placeholder', {
    props: {
      type: {
        default: 'placeholder',
        type: String
      }
    },
    template: `
      <div class="activities-today-placeholder">
        <template v-if="type == 'placeholder'">
          <span class="placehold placehold--height-32 placehold--margin-bottom-19 placehold--width-30-percent"></span>
          <span class="placehold placehold--height-5 placehold--width-60-percent"></span>
        </template>
        <template v-else>
          <p class="activities-today-placeholder__alert">You must setup Google Analytics to view this information.</p>
        </template>
      </div>
    `
  })

  export default {
    name: 'todaySidebar',
    props: {
    },
    components: {
      'placeholder': Placeholder,
      'today-tile': TodayTile
    },
    mixins: [helpers, refresh],
    data () {
      return {
        aov: null,
        dashboards: null,
        googleIntegrated: null,
        googleToday: null,
        orders: null,
        sales: null,
        now: null,
        salesByHour: {
          labels: [
            '12am', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am',
            '9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm',
            '6pm', '7pm', '8pm', '9pm', '10pm', '11pm'
          ],
          datasets: []
        },
        scrollMagicProgress: null,
        sidebarController: null,
        topCustomer: null,
        topProducts: null,
        unfulfilledOrders: null
      }
    },
    methods: {
      applyDashboards () {
        this.aov = this.dashboardByName('Average Order Value')
        this.orders = this.dashboardByName('Total Orders')
        this.sales = this.dashboardByName('Gross Sales')
        this.scrollMagicFadeInUpdate()
        this.$emit('updateIScroll')
      },
      applySalesByHour (sales) {
        this.salesByHour.datasets = [{
          data: [],
          backgroundColor: '#f1f1f1',
          labels: this.salesByHour.labels
        }]
        let salesKeyed = _keyBy(sales, function (o) {
          return moment(o.date).hour()
        })

        if (sales.length > 0) {
          for (let i = 0; i <= 23; i++) {
            let value = 0

            if (_has(salesKeyed, i)) {
              value = salesKeyed[i].total_price
            }

            this.salesByHour.datasets[0].data.push(value)
          }
        }
      },
      dashboardByName (name) {
        let dashboard = _find(this.dashboards, {'name': name})
        return dashboard
      },
      isActive () {
        let html = document.querySelector('html')
        let realtimeActive = html.classList.contains('realtime-active')
        let todayActive = html.classList.contains('today-active')

        return ifvisible.now() && (todayActive || (this.getBreakpoint() >= 1200 && !realtimeActive))
      },
      loadDashboardsData () {
        // Get platform realtime data
        let that = this

        return axios({
          url: `${that.$domain}/order_sales_dashboard`,
          params: that.params
        })
        .then((response) => {
          that.dashboards = response.data.dashboards
          that.applyDashboards()
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadData (force = false) {
        if (force || this.isActive()) {
          this.now = moment()
          this.params = {
            end: this.now.format(),
            start: this.now.clone().startOf('day').format()
          }
          this.loadDashboardsData()
          this.loadSalesData()
          this.loadTopProductsData()
          this.loadTopCustomerData()
          this.loadGoogleData()
          this.loadUnfulfilledOrderData()
        }
      },
      loadGoogleData () {
        // Get google analytics today data
        let that = this

        return axios({
          url: `integration/google/analytics/${that.$domain}/today`
        })
        .then((response) => {
          that.googleToday = response.data
          this.scrollMagicFadeInUpdate()
          this.$emit('updateIScroll')
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadSalesData () {
        let that = this

        return axios({
          url: `${that.$domain}/order_sales`,
          params: that.params
        })
        .then((response) => {
          that.applySalesByHour(response.data.order_sales)
          this.scrollMagicFadeInUpdate()
          this.$emit('updateIScroll')
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadTopProductsData () {
        let that = this
        let params = _clone(that.params)
        params['group_by'] = 'product_id'

        return axios({
          url: `${that.$domain}/top_results`,
          params: params
        })
        .then((response) => {
          let result = response.data.top_results

          if (result.length > 0) {
            that.topProducts = result
          } else {
            that.topProducts = false
          }

          this.scrollMagicFadeInUpdate()
          this.$emit('updateIScroll')
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadTopCustomerData () {
        let that = this
        let params = _clone(that.params)
        params['group_by'] = 'customer_id'
        params['limit'] = 1

        return axios({
          url: `${that.$domain}/top_results`,
          params: params
        })
        .then((response) => {
          if (response.data.top_results.length > 0) {
            that.topCustomer = response.data.top_results[0]
          } else {
            this.topCustomer = false
          }

          this.scrollMagicFadeInUpdate()
          this.$emit('updateIScroll')
        })
        .catch((error) => {
          console.log(error)
        })
      },
      loadUnfulfilledOrderData () {
        let that = this

        return axios({
          url: `platforms/shopify/orders_unfulfilled/${that.$domain}`,
          params: that.params
        })
        .then((response) => {
          that.unfulfilledOrders = response.data
          this.scrollMagicFadeInUpdate()
          this.$emit('updateIScroll')
        })
        .catch((error) => {
          console.log(error)
        })
      },
      scrollMagicFadeIn () {
        if (this.$firefox === false) {
          Vue.nextTick(() => {
            let fadeElements = document.querySelectorAll('.scrollmagic__today-fade-in-up')
            let html = document.querySelector('html')

            this.scrollMagicProgress = null

            if (this.sidebarController === null) {
              this.sidebarController = new ScrollMagic.Controller()

              for (let fadeElement of fadeElements) {
                let scene = new ScrollMagic.Scene({ // eslint-disable-line no-unused-vars
                  triggerElement: fadeElement,
                  triggerHook: 0.9,
                  reverse: false
                })
                .setClassToggle(fadeElement, 'scrollmagic__today-fade-in-up--show')
                // .addIndicators() // Debug tool for scrollmagic
                .addTo(this.sidebarController)

                this.scrollMagicProgress = scene.progress()
              }
            }

            if (html.classList.contains('scrollmagic-today-loading')) {
              html.classList.remove('scrollmagic-today-loading')
            }
          })
        }
      },
      scrollMagicFadeInDestroy () {
        if (this.$firefox === false) {
          if (this.sidebarController !== null) {
            let items = this.$el.querySelectorAll('.scrollmagic__today-fade-in-up')

            for (let item of items) {
              if (item.classList.contains('scrollmagic__today-fade-in-up--show')) {
                item.classList.remove('scrollmagic__today-fade-in-up', 'scrollmagic__today-fade-in-up--show')
              }
            }

            this.sidebarController.destroy(true)
            this.sidebarController = null
          }
        }
      },
      scrollMagicFadeInUpdate () {
        if (this.$firefox === false) {
          let items = this.$el.querySelectorAll('.scrollmagic__today-fade-in-up')

          if (items.length > 0) {
            this.scrollMagicFadeInDestroy()

            let scrollMagicReady = setInterval(() => {
              this.scrollMagicFadeIn()

              if (this.scrollMagicProgress !== null) {
                clearInterval(scrollMagicReady)
              }
            }, 100)
          }
        }
      }
    },
    mounted () {
      window.addEventListener('load', () => {
        this.scrollMagicFadeIn()
      })
    },
    created () {
      this.loadData()

      if (this.$firefox === false) {
        document.querySelector('html').classList.add('scrollmagic-today-loading')
      }

      this.$parent.$on('googleIntegrated', (boolean) => {
        this.googleIntegrated = boolean
        this.scrollMagicFadeInUpdate()
        this.$emit('updateIScroll')
      })
    },
    watch: {
      '$parent.navigationActive': function () {
        if (this.$parent.navigationActive === 'today') {
          this.loadData(true)
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/js/components/TodaySidebar.vue